import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const _matSnackBar = inject(MatSnackBar);

  // Obtén el token desde localStorage
  const token = localStorage.getItem('tokenback');

  // Clona la solicitud y agrega el token al encabezado si está disponible
  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  return next(authReq).pipe(
    catchError((err) => {
      if (err.status === 401) {
        // Ignorar redirección global para el endpoint de validación de correo
        if (req.url.includes('/email-dos')) {
          return throwError(() => err);
        }

        // Muestra un mensaje de error y realiza acciones específicas si es necesario
        _matSnackBar.open(
          'Sesión no válida. Por favor, inicia sesión nuevamente.',
          'X',
          {
            duration: 10000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          }
        );
        // Opcional: limpia el token o redirige al usuario
        localStorage.removeItem('tokenback'); // Limpia el token
        let rutaLogin = '/ES/inicio-sesion/' + localStorage.getItem('slug');
        window.location.href = rutaLogin; // Redirige al login o maneja la sesión
      }
      return throwError(() => err); // Reenvía el error para que otros lo manejen
    })
  );
};
